/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Booking_PolicyInputs */

const en_features_booking_policy = /** @type {(inputs: Features_Booking_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free to cancel up to 24 h before`)
};

const pl_features_booking_policy = /** @type {(inputs: Features_Booking_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwołasz bez opłat do 24 h przed`)
};

/**
* | output |
* | --- |
* | "Free to cancel up to 24 h before" |
*
* @param {Features_Booking_PolicyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_policy = /** @type {((inputs?: Features_Booking_PolicyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_PolicyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_policy(inputs)
	return en_features_booking_policy(inputs)
});